import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkupLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.51471 20.4854L20.4853 3.51479",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgMarkupLine;
